import React from "react";
import "./Academics.css";
import studyImg from "../../assets/images/lib2.webp"; // change to your actual image

const Academics = () => {
  return (
    <section id="academics">
      <div className="academics-header">
        <h1>Our Academics</h1>
        <p>
          Alasar Academy provides a balanced education that combines modern
          knowledge with Islamic values — nurturing disciplined, confident, and
          capable students.
        </p>
      </div>

      <div className="academics-content">
        <div className="academics-image">
          <img src={studyImg} alt="Academics at Alasar Academy" />
        </div>

        <div className="academics-text">
          <h2>Academic Excellence & Programs</h2>
          <p>
            Our curriculum focuses on holistic learning — developing intellectual,
            moral, and social growth. We offer structured programs designed to
            prepare students for success in school, college, and beyond.
          </p>

          <ul className="program-list">
            <li>📘 Primary & Middle School Education</li>
            <li>🧮 Matriculation (Science & Arts)</li>
            <li>💻 Intermediate (Pre-Medical, Pre-Engineering, Computer Science)</li>
            <li>🎓 Degree Programs & Skill-Based Courses</li>
          </ul>

          <a href="#admission" className="learn-more-btn">
            Explore Programs →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Academics;
